module.exports = __webpack_public_path__ + "img/unity-environment-part2.8acc658b.png";